import { AsyncPipe } from '@angular/common';
import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { fadeInOutAnimation } from '@app/core/animations';
import { App } from '@app/core/models/app.model';
import { SetCurrentApp } from '@app/core/states/app.actions';
import { AppState } from '@app/core/states/app.state';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { UiModule } from '@app/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-switch-apps',
  imports: [UiModule, TranslatePipe, AsyncPipe],
  templateUrl: './switch-apps.component.html',
  styleUrl: './switch-apps.component.scss',
  animations: [fadeInOutAnimation],
})
export class SwitchAppsComponent {
  apps$: Observable<App[]> = inject(Store).select(AppState.apps);
  currentAppId$: Observable<number> = inject(Store).select(AppState.currentAppId);
  showList = false;
  private readonly store = inject(Store);
  private readonly elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showList = false;
    }
  }

  onButtonClick() {
    this.showList = !this.showList;

    // tracking
    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonOpenAppList',
        component: 'PagePublishing',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  setCurrentApp(appId: number) {
    this.store.dispatch(new SetCurrentApp(appId));
    this.showList = false;
  }
}
